var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_71_711)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.049 175C91.443 175.155 67.2317 151.023 66.9442 121.096C66.6678 91.4788 91.0119 67.0262 120.895 66.8825C150.523 66.7387 174.713 90.8484 174.989 120.786C175.265 150.404 150.943 174.845 121.038 175H121.049ZM142.641 120.853C142.099 121.428 141.701 121.859 141.281 122.28C137.168 126.405 133.022 130.497 128.943 134.655C126.887 136.745 126.887 140.019 128.832 142.021C130.8 144.034 134.051 144.155 136.173 142.076C142.033 136.314 147.848 130.497 153.608 124.635C155.697 122.512 155.697 119.404 153.608 117.281C147.848 111.419 142.033 105.602 136.173 99.8398C134.073 97.7717 130.789 97.8712 128.821 99.884C126.876 101.875 126.909 105.126 128.932 107.25C130.281 108.665 131.696 110.026 133.089 111.408C136.251 114.549 139.413 117.679 142.641 120.864V120.853ZM99.3366 120.941C99.7567 120.488 100.111 120.09 100.486 119.714C104.522 115.666 108.579 111.629 112.603 107.581C114.947 105.226 115.113 102.007 113.023 99.873C110.934 97.7385 107.65 97.8491 105.318 100.172C99.7236 105.746 94.1406 111.331 88.5797 116.927C86.0701 119.448 86.0701 122.445 88.5907 124.978C94.1627 130.574 99.7346 136.159 105.329 141.733C107.672 144.078 110.923 144.166 113.023 142.01C115.08 139.897 114.969 136.701 112.703 134.423C108.634 130.32 104.544 126.25 100.464 122.169C100.088 121.793 99.7346 121.395 99.3145 120.941H99.3366Z",
    fill: "url(#paint0_linear_71_711)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1887 25C96.0975 25.1991 109.475 26.117 122.509 29.7888C127.174 31.1048 131.718 32.7859 135.565 35.8825C138.904 38.57 140.949 41.8768 139.888 46.4001C139.335 48.7669 137.909 50.6138 136.085 52.1511C132.005 55.6016 127.097 57.3822 122.067 58.7978C114.195 61.0208 106.125 62.0825 97.9879 62.7793C88.7456 63.5645 79.5033 63.6861 70.2609 63.0115C58.7522 62.171 47.2767 60.9434 36.5198 56.409C33.7117 55.2256 30.9589 53.5667 28.6815 51.5539C23.7508 47.2296 23.9387 41.0252 28.8363 36.6346C32.573 33.2836 37.1278 31.514 41.8374 30.0874C49.72 27.6985 57.8236 26.4599 66.0267 25.8405C71.5544 25.4203 77.1042 25.188 80.1998 25L80.1887 25Z",
    fill: "url(#paint1_linear_71_711)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7394 73.7723C76.3414 74.2258 76.0982 74.5465 75.8107 74.8341C68.7574 81.9232 63.4176 90.0851 60.1784 99.5742C59.8909 100.404 59.5703 100.791 58.5753 100.691C48.8797 99.729 39.2504 98.4682 30.0302 95.1393C24.9779 93.3255 25 93.2702 25 87.9949C25 80.0431 25 72.0913 25 64.1395V62.2041C41.0746 71.5715 58.7412 72.9097 76.7394 73.7723Z",
    fill: "url(#paint2_linear_71_711)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1106 104.252C35.4695 108.322 46.2817 109.727 57.2266 110.966C55.5351 122.954 56.8065 134.5 61.5272 145.891C58.6859 145.482 56.11 145.184 53.5562 144.741C47.0225 143.591 40.4887 142.286 34.563 139.189C32.0092 137.851 29.6654 135.993 27.4875 134.08C25.7186 132.532 25.0332 130.231 25.0222 127.864C24.989 120.244 25.0111 112.613 25.0222 104.993C25.0222 104.794 25.0664 104.595 25.1217 104.252H25.1106Z",
    fill: "url(#paint3_linear_71_711)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_71_711",
    x1: 120.967,
    y1: 66.8818,
    x2: 120.967,
    y2: 175.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_71_711",
    x1: 82.6209,
    y1: 25,
    x2: 82.6209,
    y2: 63.4508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_71_711",
    x1: 50.8697,
    y1: 62.2041,
    x2: 50.8697,
    y2: 100.706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_71_711",
    x1: 43.2659,
    y1: 104.252,
    x2: 43.2659,
    y2: 145.891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_71_711"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white",
    transform: "translate(25 25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackend);
export default __webpack_public_path__ + "static/media/Backend.30cc94a54dd602820d85ce66c5b4dc5c.svg";
export { ForwardRef as ReactComponent };